// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-line"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M20.5 8L15.5 13L11.5 9L6.5 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChartLineIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-line',
    ref,
    icon: element,
  },
));

ChartLineIcon.displayName = 'ChartLineIcon';

export default ChartLineIcon;
